import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import vSelect from 'vue-select'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import moment from 'moment'
import Clipboard from 'v-clipboard'
import { GridGlobal } from 'gridjs-vue'
import { EagleModal } from 'vue-eagle-modal'
import VueConfirmDialog from 'vue-confirm-dialog'
import Vuelidate from 'vuelidate'
import VueRandomColor from 'vue-randomcolor'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'nprogress/nprogress.css'
import 'flag-icon-css/css/flag-icon.css'
import 'vue-select/dist/vue-select.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// import VueSocketIOExt from 'vue-socket.io-extended'
// import io from 'socket.io-client'

// const socket = io('http://127.0.0.1:5001')

// Vue.use(VueSocketIOExt, socket, { store })
Vue.use(BootstrapVue)
Vue.use(GridGlobal)
Vue.use(VueConfirmDialog)
Vue.use(EagleModal)
Vue.use(BootstrapVueIcons)
Vue.use(VueCookies)
Vue.use(Clipboard)
Vue.use(Vuelidate)
Vue.use(VueRandomColor)
Vue.config.productionTip = false
Vue.component('v-select', vSelect)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

// Global filters
Vue.filter('truncate', function (text, stop, clamp) {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

Vue.filter('fromNow', function (text) {
  return moment.utc(text).fromNow()
})

Vue.filter('roundChars', function (x) {
  if (x < 1000) {
    return x
  }
  return Math.round((x / 1000) * 10) / 10 + 'K'
})

function round (value, precision) {
  var multiplier = Math.pow(10, precision || 0)
  return Math.round(value * multiplier) / multiplier
}

Vue.filter('timedelta', function (ms) {
  var secs = round(ms / 1000, 1)
  return `${secs} sec`
})

window.vapp = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
